import React, { useContext, useEffect } from 'react'
import Clients from '../elements/clients'
import { useDispatch, useSelector } from "react-redux";
import { fetchClients } from "../redux/actions";
import { Loader } from "../elements/loader";
import { Carcontext } from "../context/carcontext";

const ClientsList = () => {

    const dispatch = useDispatch()
    const clients = useSelector((state) => {
        return state.clients.client
    })
    const loading = useSelector(state => state.app.loading)
    const { theme } = useContext(Carcontext)

    useEffect(() => {
        if (clients.length > 0) {
            return
        } else {
            dispatch(fetchClients())
        }
    }, [])

    if (loading) {
        return <Loader theme={theme} />
    }

    return (
        <div className="cards clients">
            {
                clients.map((person, index) => <Clients person={person} key={index} />)
            }
        </div>
    )
}

export default ClientsList